// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBatteryHorizontalCharging30Solid = (
  props: SVGProps<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m8.846 16-.244 1.382c-.037.212-.033.421.008.618H4a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h6.281L9.15 8H7.8v2.385l-.841 1.487a1.618 1.618 0 0 0-.048 1.5c.158.325.462.65.889.797V16zM18 8h-4.846l.244-1.382A1.636 1.636 0 0 0 13.39 6H18a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-6.281l1.132-2H18a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1zm4 2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-.5v-4zM8.047 12.487l3.582-6.332c.176-.31.602-.116.538.245l-.813 4.6h2.35c.234 0 .375.29.249.513l-3.582 6.332c-.176.31-.602.116-.538-.245l.813-4.6h-2.35c-.234 0-.375-.29-.249-.513z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBatteryHorizontalCharging30Solid;
